exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.panelScoped[data-v-2fa44014] {\n  height: 80vh;\n  width: 90%;\n  margin-left: 10%;\n}\n@media (max-width: 200px) {\n.imgPublicidad[data-v-2fa44014] {\n    width: 100%;\n}\n}\n", ""]);

// exports
